import { apiRequest } from './client';

/**
 * The second door (ADR-0019). Its own module rather than a section of
 * `queries.ts`, because none of it is a React Query hook: two of the three are
 * anonymous, and the third is a one-shot mutation with no cache to keep.
 */
export interface PasswordSession {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
}

export function signInWithPassword(email: string, password: string): Promise<PasswordSession> {
  // Anonymous by necessity: signing in is what someone does before she has a
  // token. The rate limit that makes this safe lives on the route.
  return apiRequest<PasswordSession>('/v1/auth/password/sign-in', {
    method: 'POST',
    body: { email, password },
    anonymous: true
  });
}

export function requestPasswordReset(email: string): Promise<unknown> {
  return apiRequest('/v1/auth/password/reset', {
    method: 'POST',
    body: { email },
    anonymous: true
  });
}

/** Authenticated: a password is only ever set from inside a session (ADR-0019). */
export function setPassword(password: string): Promise<unknown> {
  return apiRequest('/v1/auth/password', { method: 'POST', body: { password } });
}
